import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { GridContainer, GridRow, GridColumn, Modal } from "arv-reactcomponents";
import { PAYMENTPAGE } from 'npmlinks-constants';
import SavedCardView from "../SavedCardView";

class SavedCardModal extends PureComponent {
  render() {
    const { data, isOpen, onClose, selectedSavedCard } = this.props;
    const isModal = true;
    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <h1 className="nw-savedcardmodal-title">
          {PAYMENTPAGE.SAVEDCARDMODAL_TITLE}
        </h1>
        <GridContainer className="nw-savedcardmodal-body">
          <GridRow className="nw-savedcardmodal-bodyrow">
            {data &&
              data.map(card => (
                <GridColumn key={card.cardToken} className="nwc-grid-col-sm-6 nw-savedcardmodal-cardcol">
                  <SavedCardView.component
                    {...card}
                    selectedSavedCard={selectedSavedCard}
                    isModal={isModal}
                  />
                </GridColumn>
              ))}
          </GridRow>
        </GridContainer>
      </Modal>
    );
  }
}

SavedCardModal.propTypes = {
  data: PropTypes.shape({}).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedSavedCard: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: SavedCardModal,
  component: SavedCardModal,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentSavedCard/SavedCardModal/index.js